import { getEnv } from './envConfig'
let env = getEnv()

export const ENDPOINT = env.ENDPOINT
export const KEYCLOAK = env.KEYCLOAK
export const KEYCLOAK_CLOUD = env.KEYCLOAK_CLOUD
//*********************************************************************************************** */


//Microservices

export const NOTIFICATIONS_MICROSERVICE = ENDPOINT + 'swasthanotification/api/'
// export const FINANCE_MICROSERVICE = ENDPOINT + 'ayurwedafinance/api/'
export const LIFE_TRAVELER_MICROSERVICE = ENDPOINT + 'api/'
export const LIFE_TRAVELER_UPLOADS_MICROSERVICE = ENDPOINT


//export const PROCUREMENT_MICROSERVICE = ENDPOINT + 'swasthaprocurement/api/'

export const FILE_UPLOAD_MICROSERVICE = ENDPOINT + 'api/upload/'

export const COMMON_UPLOAD_FILE_VIEW = ENDPOINT + "api/uploaded_files"

export const GET_UPLOADED_FILES = ENDPOINT + "api/file_upload_items"

export const UPLOAD_FILES = ENDPOINT + "api/uploads"

//Keycloack API Routes
export const USER_LOGIN = KEYCLOAK + 'realms/lyfetraveller/protocol/openid-connect/token'
export const USER_GET_KEYCLOAK = KEYCLOAK + 'admin/realms/lyfetraveller/users'
export const USER_LOGIN_CLOUD = KEYCLOAK_CLOUD + 'realms/lyfetraveller/protocol/openid-connect/token'

export const FILE_VIEW = ENDPOINT + 'api/uploaded_files/'

export const AGODA_SEARCHES = ENDPOINT + 'api/agoda_searches'
export const AGODA_CITIES = ENDPOINT + 'api/agoda_cities'


// Notifications
// export const NOTIFICATIONS = NOTIFICATIONS_MICROSERVICE + 'push_notifications'

//Hotels
export const HOTELS =LIFE_TRAVELER_MICROSERVICE + 'hotels'
export const ROOMS =LIFE_TRAVELER_MICROSERVICE + 'hotel_rooms'

// user
export const USERS = LIFE_TRAVELER_MICROSERVICE + 'users/'

// all hotel facility types
export const HOTEL_FACILITY_TYPES = LIFE_TRAVELER_MICROSERVICE + 'hotel_facility_types'
export const HOTEL_FACILITY_TYPES_ITEMS = LIFE_TRAVELER_MICROSERVICE + 'hotel_facility_type_items'

// hotel categories
export const HOTEL_CATEGORIES = LIFE_TRAVELER_MICROSERVICE + 'categories'

// WellnessPackages
export const WELLNESS_PACKAGES = LIFE_TRAVELER_MICROSERVICE + 'wellness_packages'
export const WELLNESS_PACKAGES_UPLOADS = LIFE_TRAVELER_UPLOADS_MICROSERVICE + 'uploads/'
export const WELLNESS_PACKAGES_UPLOADS_SINGLE = LIFE_TRAVELER_UPLOADS_MICROSERVICE + 'uploads'

export const HOTEL_WELLNESS_PACKAGES_UPLOADS = LIFE_TRAVELER_MICROSERVICE + 'hotel_wellness_packages'



// RoomType
export const ROOM_TYPES = LIFE_TRAVELER_MICROSERVICE + 'room_types'
export const ROOM_FACILITIES = LIFE_TRAVELER_MICROSERVICE + 'room_facilities'
export const ROOM_BEDS = LIFE_TRAVELER_MICROSERVICE + 'room_beds'

// bed type
export const BED_TYPES = LIFE_TRAVELER_MICROSERVICE + 'bed_types'

// addresses
export const ADDRESSES = LIFE_TRAVELER_MICROSERVICE + 'addresses'

// hotel_house_rules
export const HOTEL_HOUSE_RULES = LIFE_TRAVELER_MICROSERVICE + 'hotel_house_rules'

// meal plans
export const MEAL_PLANS = LIFE_TRAVELER_MICROSERVICE + 'meal_plans'
export const MEAL_PLAN_PRICINGS = LIFE_TRAVELER_MICROSERVICE + 'meal_plan_pricings'

// pricing rools
export const ROOM_PRICINGS_RULES = LIFE_TRAVELER_MICROSERVICE + 'room_pricing_rules'

// cancellation policies
export const CANCELLATION_POLICIES = LIFE_TRAVELER_MICROSERVICE + 'cancellation_policies'
export const ROOM_CANCELLATION_POLICIES = LIFE_TRAVELER_MICROSERVICE + 'room_cancellation_policies'

// room recuring pricings
export const ROOM_RECURING_PRICINGS = LIFE_TRAVELER_MICROSERVICE + 'room_recuring_pricings'

// hotel facility
export const HOTEL_FACILITIES = LIFE_TRAVELER_MICROSERVICE + 'hotel_facilities'

// room hotel_languages
export const HOTEL_LANGUAGES = LIFE_TRAVELER_MICROSERVICE + 'hotel_languages'

// room hotel_accounts
export const HOTEL_ACCOUNTS = LIFE_TRAVELER_MICROSERVICE + 'hotel_accounts'

// customers
export const CUSTOMERS = LIFE_TRAVELER_MICROSERVICE + 'customers'
export const CUSTOMER_ACCOUNTS = LIFE_TRAVELER_MICROSERVICE + 'customer_accounts'

// bookings
export const BOOKINGS = LIFE_TRAVELER_MICROSERVICE + 'bookings'

// reviews
export const REVIEWS = LIFE_TRAVELER_MICROSERVICE + 'reviews'

// hotel_payouts
export const HOTEL_PAYOUTS = LIFE_TRAVELER_MICROSERVICE + 'hotel_payouts'
export const PAYOUT_SETTLEMENTS = LIFE_TRAVELER_MICROSERVICE + 'payout_settlements'


// booking_cancelations
export const BOOKING_CANCELATIONS = LIFE_TRAVELER_MICROSERVICE + 'booking_cancelations'

// dashboard functions
export const DASHBOARD_FUNCTIONS = LIFE_TRAVELER_MICROSERVICE + 'dashboard_functions'

// hotel_discounts
export const HOTEL_DISCOUNTS = LIFE_TRAVELER_MICROSERVICE + 'hotel_discounts'
// only for card type discounts
export const SYSTEM_CONFIGURATIONS = LIFE_TRAVELER_MICROSERVICE + 'system_configurations'

// room_type_unavailable_dates
export const ROOM_TYPE_UNAVAILABLE_DATES = LIFE_TRAVELER_MICROSERVICE + 'room_type_unavailable_dates'

// agent_earnings
export const AGENT_EARNINGS = LIFE_TRAVELER_MICROSERVICE + 'agent_earnings'

